export enum LicenseType {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
}

export enum LicenseVersion {
  '0.0.1' = '0.0.1',
  '2.1.42' = '2.1.42',
  '2.1.43' = '2.1.43',
  '2.1.44' = '2.1.44',
  '2.1.45' = '2.1.45',
  '2.1.46' = '2.1.46',
  '2.1.47' = '2.1.47',
  '2.1.48' = '2.1.48',
  '2.1.49' = '2.1.49',
  '2.1.50' = '2.1.50',
  '2.1.51' = '2.1.51',
  '2.1.52' = '2.1.52',
  '2.1.53' = '2.1.53',
  '2.2.0' = '2.2.0',
  '2.2.1' = '2.2.1',
  '2.2.2' = '2.2.2',
  '2.2.3' = '2.2.3',
  '2.2.22' = '2.2.22',
  '2.2.35' = '2.2.35',
  '4.0.17' = '4.0.17',
  '4.2.26' = '4.2.26',
  '4.2.31' = '4.2.31',
  '4.2.46' = '4.2.46',
  '4.2.47' = '4.2.47',
  '4.3.1' = '4.3.1',
  '4.3.2' = '4.3.2',
  '4.4.1' = '4.4.1',
  '4.4.2' = '4.4.2',
  '4.4.3' = '4.4.3',
  '4.4.4' = '4.4.4',
  '4.4.5' = '4.4.5',
  '4.4.6' = '4.4.6',
  '4.4.7' = '4.4.7',
  '4.4.8' = '4.4.8',
  '4.4.9' = '4.4.9',
  '4.4.10' = '4.4.10',
  '4.4.11' = '4.4.11',
  '4.4.12' = '4.4.12',
  '4.5.1' = '4.5.1',
  '4.6.1' = '4.6.1',
  '4.6.2' = '4.6.2',
  '4.6.3' = '4.6.3',
  '4.6.4' = '4.6.4',
  '4.6.5' = '4.6.5',
  '4.7.1' = '4.7.1',
  '4.7.2' = '4.7.2',
  '4.7.3' = '4.7.3',
  '4.7.4' = '4.7.4',
  '4.7.5' = '4.7.5',
  '4.8.1' = '4.8.1',
  '4.8.2' = '4.8.2',
  '4.8.3' = '4.8.3',
  '4.9.1' = '4.9.1',
  '4.10.1' = '4.10.1',
  '4.10.2' = '4.10.2',
  '4.10.3' = '4.10.3',
  '4.10.4' = '4.10.4',
  '4.12.1' = '4.12.1',
  '4.12.2' = '4.12.2',
  '4.12.3' = '4.12.3',
  '4.12.4' = '4.12.4',
  '4.12.5' = '4.12.5',
  '4.12.6' = '4.12.6',
  '4.12.7' = '4.12.7',
  '4.12.8' = '4.12.8',
  '4.12.9' = '4.12.9',
  '4.12.10' = '4.12.10',
  '4.12.11' = '4.12.11',
  '4.12.12' = '4.12.12',
  '4.12.13' = '4.12.13',
  '4.12.14' = '4.12.14',
  '4.12.15' = '4.12.15',
  '4.12.16' = '4.12.16',
  '4.12.17' = '4.12.17',
  '4.12.18' = '4.12.18',
  '4.12.19' = '4.12.19',
  '4.12.20' = '4.12.20',
  '4.12.21' = '4.12.21',
  '4.13.1' = '4.13.1',
  '4.13.2' = '4.13.2',
  '4.13.3' = '4.13.3',
  '4.13.4' = '4.13.4',
  '4.13.5' = '4.13.5',
  '4.13.6' = '4.13.6',
  '4.13.7' = '4.13.7',
  '4.13.8' = '4.13.8',
  '4.13.9' = '4.13.9',
  '4.13.10' = '4.13.10',
  '4.13.11' = '4.13.11',
  '4.13.12' = '4.13.12',
  '4.13.13' = '4.13.13',
  '4.13.14' = '4.13.14',
  '4.13.15' = '4.13.15',
  '4.13.16' = '4.13.16',
  '4.13.17' = '4.13.17',
  '4.13.18' = '4.13.18',
  '4.13.19' = '4.13.19',
  '4.13.20' = '4.13.20',
  '4.13.21' = '4.13.21',
  '4.13.22' = '4.13.22',
  '4.14.1' = '4.14.1',
  '4.14.2' = '4.14.2',
  '4.14.3' = '4.14.3',
  '4.14.4' = '4.14.4',
  '4.15.1' = '4.15.1',
  '4.15.2' = '4.15.2',
  '4.15.3' = '4.15.3',
  '4.15.4' = '4.15.4',
  '4.15.5' = '4.15.5',
  '4.15.6' = '4.15.6',
  '4.16.1' = '4.16.1',
  '4.16.2' = '4.16.2',
  '4.16.3' = '4.16.3',
  '4.16.4' = '4.16.4',
  '4.16.5' = '4.16.5',
  '4.16.6' = '4.16.6',
  '4.16.7' = '4.16.7',
  '4.16.8' = '4.16.8',
  '4.17.1' = '4.17.1',
  '4.17.2' = '4.17.2',
  '4.17.3' = '4.17.3',
  '4.17.4' = '4.17.4',
  '4.17.5' = '4.17.5',
  '4.17.6' = '4.17.6',
  '4.17.7' = '4.17.7',
  '4.18.1' = '4.18.1',
  '4.18.2' = '4.18.2',
  '4.18.3' = '4.18.3',
  '4.18.4' = '4.18.4',
  '4.19.1' = '4.19.1',
  '4.20.1' = '4.20.1',
  '4.20.2' = '4.20.2',
  '4.20.3' = '4.20.3',
  '4.20.4' = '4.20.4',
  '4.20.5' = '4.20.5',
  '4.20.6' = '4.20.6',
  '4.20.7' = '4.20.7',
  '4.21.1' = '4.21.1',
  '4.21.2' = '4.21.2',
  '4.21.3' = '4.21.3',
  '4.21.4' = '4.21.4',
  '4.21.5' = '4.21.5',
  '4.21.6' = '4.21.6',
  '4.21.7' = '4.21.7',
  '4.21.8' = '4.21.8',
  '4.22.1' = '4.22.1',
  '4.22.2' = '4.22.2',
  '4.22.3' = '4.22.3',
  '4.22.4' = '4.22.4',
  '4.22.5' = '4.22.5',
  '4.22.6' = '4.22.6',
  '4.22.7' = '4.22.7',
  '4.22.8' = '4.22.8',
  '4.22.9' = '4.22.9',
  '4.22.10' = '4.22.10',
  '4.22.11' = '4.22.11',
  '4.22.12' = '4.22.12',
  '4.22.13' = '4.22.13',
  '4.22.14' = '4.22.14',
  '4.22.15' = '4.22.15',
  '4.22.16' = '4.22.16',
  '4.22.17' = '4.22.17',
  '4.22.18' = '4.22.18',
  '4.22.19' = '4.22.19',
  '4.23.1' = '4.23.1',
  '4.24.1' = '4.24.1',
  '4.24.2' = '4.24.2',
  '4.24.4' = '4.24.4',
  '4.24.5' = '4.24.5',
  '4.24.6' = '4.24.6',
  '4.24.7' = '4.24.7',
  '4.24.8' = '4.24.8',
  '4.24.9' = '4.24.9',
  '4.25.1' = '4.25.1',
  '4.25.2' = '4.25.2',
  '4.25.3' = '4.25.3',
  '4.25.4' = '4.25.4',
  '4.25.5' = '4.25.5',
  '4.25.6' = '4.25.6',
  '4.25.7' = '4.25.7',
  '4.26.1' = '4.26.1',
  '4.26.2' = '4.26.2',
  '4.26.3' = '4.26.3',
  '4.26.4' = '4.26.4',
  '4.26.5' = '4.26.5',
  '4.26.6' = '4.26.6',
  '4.27.1' = '4.27.1',
  '4.28.1' = '4.28.1',
  '4.28.2' = '4.28.2',
  '4.28.3' = '4.28.3',
  '4.28.4' = '4.28.4',
  '4.28.5' = '4.28.5',
  '4.28.6' = '4.28.6',
  '4.28.7' = '4.28.7',
  '4.28.8' = '4.28.8',
  '4.28.9' = '4.28.9',
  '4.28.10' = '4.28.10',
  '4.28.11' = '4.28.11',
  '4.28.12' = '4.28.12',
  '4.28.13' = '4.28.13',
  '4.28.14' = '4.28.14',
  '4.29.1' = '4.29.1',
  '4.29.2' = '4.29.2',
  '4.29.3' = '4.29.3',
  '4.29.4' = '4.29.4',
  '4.29.5' = '4.29.5',
  '4.30.2' = '4.30.2',
  '4.31.0' = '4.31.0',
  '4.31.1' = '4.31.1',
  '4.31.2' = '4.31.2',
  '4.31.3' = '4.31.3',
  '4.31.4' = '4.31.4',
  '4.31.5' = '4.31.5',
  '4.31.6' = '4.31.6',
  '4.31.7' = '4.31.7',
  '4.31.8' = '4.31.8',
  '4.31.9' = '4.31.9',
  '4.31.10' = '4.31.10',
  '4.31.11' = '4.31.11',
  '4.31.12' = '4.31.12',
  '4.31.13' = '4.31.13',
  '4.31.14' = '4.31.14',
  '4.31.15' = '4.31.15',
  '4.31.16' = '4.31.16',
  '4.31.17' = '4.31.17',
  '4.31.18' = '4.31.18',
  '4.31.19' = '4.31.19',
  '4.31.20' = '4.31.20',
  '4.32.1' = '4.32.1',
  '4.32.2' = '4.32.2',
  '4.33.1' = '4.33.1',
  '4.34.1' = '4.34.1',
  '4.35.1' = '4.35.1',
  '4.35.2' = '4.35.2',
  '4.36.1' = '4.36.1',
  '4.37.1' = '4.37.1',
  '4.37.2' = '4.37.2',
  '4.37.3' = '4.37.3',
  '4.37.4' = '4.37.4',
  '4.37.5' = '4.37.5',
  '4.38.1' = '4.38.1',
  '4.38.2' = '4.38.2',
  '4.38.3' = '4.38.3',
  '4.38.11' = '4.38.11',
  '4.38.13' = '4.38.13',
  '4.39.1' = '4.39.1',
  '4.39.2' = '4.39.2',
  '4.39.3' = '4.39.3',
  '4.39.4' = '4.39.4',
  '4.40.1' = '4.40.1',
  '4.40.2' = '4.40.2',
  '4.40.3' = '4.40.3',
  '4.41.1' = '4.41.1',
  '4.41.2' = '4.41.2',
  '4.42.1' = '4.42.1',
  '4.42.2' = '4.42.2',
  '4.42.3' = '4.42.3',
  '4.42.4' = '4.42.4',
  '4.42.7' = '4.42.7',
  '4.42.8' = '4.42.8',
  '4.43.0' = '4.43.0',
  '4.43.2' = '4.43.2',
  '4.43.3' = '4.43.3',
  '4.43.4' = '4.43.4',
  '4.43.5' = '4.43.5',
  '4.44.0' = '4.44.0',
  '4.44.1' = '4.44.1',
  '4.44.2' = '4.44.2',
  '4.44.3' = '4.44.3',
  '4.44.4' = '4.44.4',
  '4.44.5' = '4.44.5',
  '4.44.6' = '4.44.6',
  '4.45.1' = '4.45.1',
  '4.45.2' = '4.45.2',
  '4.46.1' = '4.46.1',
  '4.46.2' = '4.46.2',
  '4.47.1' = '4.47.1',
  '4.47.2' = '4.47.2',
  '4.47.3' = '4.47.3',
  '4.47.4' = '4.47.4',
  '4.47.5' = '4.47.5',
  '4.47.6' = '4.47.6',
  '4.48.1' = '4.48.1',
  '4.49.1' = '4.49.1',
  '4.49.2' = '4.49.2',
  '4.49.3' = '4.49.3',
  '4.49.4' = '4.49.4',
  '4.49.5' = '4.49.5',
  '4.49.6' = '4.49.6',
  '4.49.7' = '4.49.7',
  '4.49.8' = '4.49.8',
  '4.49.9' = '4.49.9',
  '4.49.10' = '4.49.10',
  '4.49.11' = '4.49.11',
  '4.49.12' = '4.49.12',
  '4.49.13' = '4.49.13',
  '4.49.14' = '4.49.14',
  '4.49.16' = '4.49.16',
  '4.50.1' = '4.50.1',
  '4.50.2' = '4.50.2',
  '4.50.3' = '4.50.3',
  '4.51.1' = '4.51.1',
  '4.51.2' = '4.51.2',
  '4.51.3' = '4.51.3',
  '4.51.4' = '4.51.4',
  '4.51.5' = '4.51.5',
  '4.51.6' = '4.51.6',
  '4.51.7' = '4.51.7',
  '4.51.8' = '4.51.8',
  '4.51.9' = '4.51.9',
  '4.51.10' = '4.51.10',
  '4.51.11' = '4.51.11',
  '4.51.14' = '4.51.14',
  '4.51.17' = '4.51.17',
  '4.51.18' = '4.51.18',
  '4.51.19' = '4.51.19',
  '4.51.20' = '4.51.20',
  '4.51.22' = '4.51.22',
  '4.52.5' = '4.52.5',
  '4.52.6' = '4.52.6',
  '4.53.1' = '4.53.1',
  '4.53.2' = '4.53.2',
  '4.53.3' = '4.53.3',
  '4.53.5' = '4.53.5',
  '4.53.6' = '4.53.6',
  '4.53.8' = '4.53.8',
  '4.53.10' = '4.53.10',
  '4.53.15' = '4.53.15',
  '4.54.5' = '4.54.5',
  '4.54.6' = '4.54.6',
  '4.54.7' = '4.54.7',
  '4.54.9' = '4.54.9',
  '4.54.10' = '4.54.10',
  '4.54.11' = '4.54.11',
  '4.55.1' = '4.55.1',
  '4.55.5' = '4.55.5',
  '4.55.9' = '4.55.9',
  '4.55.10' = '4.55.10',
  '4.55.13' = '4.55.13',
  '4.55.14' = '4.55.14',
  '4.55.16' = '4.55.16',
  '4.55.17' = '4.55.17',
  '4.55.19' = '4.55.19',
  '4.56.1' = '4.56.1',
  '4.56.2' = '4.56.2',
  '4.56.3' = '4.56.3',
  '4.56.5' = '4.56.5',
  '4.56.6' = '4.56.6',
  '4.56.7' = '4.56.7',
  '4.56.8' = '4.56.8',
  '4.56.9' = '4.56.9',
  '4.56.10' = '4.56.10',
  '4.56.11' = '4.56.11',
  '4.56.12' = '4.56.12',
  '4.56.13' = '4.56.13',
  '4.56.14' = '4.56.14',
  '4.56.15' = '4.56.15',
  '4.56.24' = '4.56.24',
  '4.56.25' = '4.56.25',
  '4.56.26' = '4.56.26',
  '4.56.27' = '4.56.27',
  '4.56.28' = '4.56.28',
  '4.56.29' = '4.56.29',
  '4.56.30' = '4.56.30',
  '4.56.31' = '4.56.31',
  '4.56.35' = '4.56.35',
  '4.57.2' = '4.57.2',
  '4.57.3' = '4.57.3',
  '4.57.4' = '4.57.4',
  '4.57.5' = '4.57.5',
  '4.57.7' = '4.57.7',
  '4.58.1' = '4.58.1',
  '4.58.2' = '4.58.2',
  '4.58.5' = '4.58.5',
  '4.58.6' = '4.58.6',
  '4.58.7' = '4.58.7',
  '4.58.10' = '4.58.10',
  '4.58.13' = '4.58.13',
  '4.58.14' = '4.58.14',
  '4.58.15' = '4.58.15',
  '4.58.16' = '4.58.16',
  '4.58.17' = '4.58.17',
  '4.59.1' = '4.59.1',
  '4.59.3' = '4.59.3',
  '4.59.12' = '4.59.12',
  '4.59.14' = '4.59.14',
  '4.59.16' = '4.59.16',
  '4.60.1' = '4.60.1',
  '4.60.2' = '4.60.2',
  '4.60.3' = '4.60.3',
  '4.60.4' = '4.60.4',
  '4.60.6' = '4.60.6',
  '4.60.7' = '4.60.7',
  '4.60.8' = '4.60.8',
  '4.60.9' = '4.60.9',
  '4.61.1' = '4.61.1',
  '4.61.2' = '4.61.2',
  '4.61.3' = '4.61.3',
  '4.61.4' = '4.61.4',
  '4.61.5' = '4.61.5',
  '4.61.7' = '4.61.7',
  '4.61.9' = '4.61.9',
  '4.61.11' = '4.61.11',
  '4.62.2' = '4.62.2',
  '4.62.3' = '4.62.3',
  '4.62.4' = '4.62.4',
  '4.62.5' = '4.62.5',
  '4.62.7' = '4.62.7',
  '4.62.8' = '4.62.8',
  '4.62.10' = '4.62.10',
  '4.62.22' = '4.62.22',
  '4.62.23' = '4.62.23',
  '4.62.24' = '4.62.24',
  '4.62.25' = '4.62.25',
  '4.62.26' = '4.62.26',
  '4.62.27' = '4.62.27',
  '4.62.28' = '4.62.28',
  '4.62.29' = '4.62.29',
  '4.62.37' = '4.62.37',
  '4.62.40' = '4.62.40',
  '4.62.41' = '4.62.41',
  '4.62.43' = '4.62.43',
  '4.62.45' = '4.62.45',
  '4.63.1' = '4.63.1',
  '4.63.2' = '4.63.2',
  '4.63.3' = '4.63.3',
  '4.63.4' = '4.63.4',
  '4.63.5' = '4.63.5',
  '4.63.7' = '4.63.7',
  '4.63.8' = '4.63.8',
  '4.63.9' = '4.63.9',
  '4.63.10' = '4.63.10',
  '4.63.11' = '4.63.11',
  '4.63.12' = '4.63.12',
  '4.63.13' = '4.63.13',
  '4.63.14' = '4.63.14',
  '4.63.15' = '4.63.15',
  '4.63.16' = '4.63.16',
  '4.63.17' = '4.63.17',
  '4.63.18' = '4.63.18',
  '4.63.19' = '4.63.19',
  '4.64.1' = '4.64.1',
  '4.64.2' = '4.64.2',
  '4.81.16' = '4.81.16',
}

export enum QrCodeVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export interface Limits {
  usersNumber?: number;
  maximumUsersNumber?: number;
  scalesNumber?: number;
  locationsNumber?: number;
  maximumMeasurementsNumber?: number;
  additionalFieldsNumber?: number;
  allowGenerateReports: boolean;
  addWatermark: boolean;
  allowApiAccess: boolean;
  allowEdgeDeviceConfigurationUpdate: boolean;
  usePolishBDOLanguage: boolean;
  turnOnHttpNodeAuth: boolean;
  turnOnAutomaticZeroing: boolean;
  qrCodeVersion: QrCodeVersion;
}

export interface License {
  id: string;
  name: string;
  customerId: string;
  email: string;
  deviceKey?: string;
  licenseKey?: string;
  version: LicenseVersion;
  type: LicenseType;
  expirationDate?: Date;
  subscriptionModules: string[];
  companyName: string;
  limits?: Limits;
  remarks?: string;
}
